
        var result = require("!!../../../../node_modules/css-loader/index.js!./bookmarked.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/tenders/bookmarked.component.css
// module id = 1493
// module chunks = 0